"use client"

import { useRef, useEffect, useState } from "react"

interface ShopHeroNameProps {
  name: string
  scale: number
}

export const ShopHeroName = ({ name, scale }: ShopHeroNameProps) => {
  const width = 110 * scale
  const height = 12 * scale
  const left = 125 * scale
  const top = 74 * scale

  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const [fontScale, setFontScale] = useState(1)
  const baseFontSize = Math.max(8, 11 * scale)

  // Auto-scale text to fit container
  useEffect(() => {
    if (!containerRef.current || !textRef.current) return

    // Reset scale to measure true width
    setFontScale(1)

    // Use requestAnimationFrame to ensure DOM has updated
    requestAnimationFrame(() => {
      if (!containerRef.current || !textRef.current) return
      const containerWidth = containerRef.current.offsetWidth
      const textWidth = textRef.current.scrollWidth

      if (textWidth > containerWidth && containerWidth > 0) {
        // Calculate scale to fit, with a minimum of 0.6
        const newScale = Math.max(0.6, containerWidth / textWidth)
        setFontScale(newScale)
      } else {
        setFontScale(1)
      }
    })
  }, [name, scale, baseFontSize])

  return (
    <div
      ref={containerRef}
      id="shop-hero-name"
      className="absolute flex items-center justify-center overflow-hidden"
      style={{
        left,
        top,
        width,
        height,
      }}
    >
      <span
        ref={textRef}
        className="text-white font-bold text-center whitespace-nowrap drop-shadow-lg"
        style={{
          fontSize: baseFontSize * fontScale,
          textShadow: "0 1px 2px black",
        }}
      >
        {name}
      </span>
    </div>
  )
}
